import React from "react"
import { useCallback } from "react"
import { Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "providers/i18n"
import { OccupantListItem } from "components/domains/occupants"
import { CustomIcon } from "components/icons"
import get from "lodash/get"

export const TouristPrivilegeListItem = ({ occupant }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { name, logo, unit, kiosk, privilege } = occupant?.properties
  const { description } = privilege.properties
  const locatedLevel =
    kiosk?.properties.level?.properties || unit?.properties.level?.properties

  const handleClick = useCallback(
    () => navigate(`/maps/place/${occupant.id}`),
    [navigate, occupant?.id]
  )

  const categoryIcon = get(
    occupant,
    "properties.local_categories[0].properties.icon_path"
  )

  return (
    <OccupantListItem
      key={`tourist-privilege-item-${occupant.id}`}
      occupant={occupant}
      onClick={handleClick}
      icon={
        !logo?.url &&
        categoryIcon && (
          <CustomIcon path={categoryIcon} sx={{ fontSize: "2.275rem" }} />
        )
      }
      logo={logo?.url}
      primary={
        <Typography component="h6" variant="title" color="text.primary">
          {t(name)}
        </Typography>
      }
      secondary={
        <>
          <Typography component="p" variant="subTitle" color="text.secondary">
            {locatedLevel && `${locatedLevel?.name?.en} Floor`}
          </Typography>
          <Typography component="p" variant="subTitle" color="text.primary">
            {t(description)}
          </Typography>
        </>
      }
    />
  )
}
